export default function QuoteBand() {
  return (
    <section className="bg-brand-terracotta py-20" data-testid="quote-band">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className="font-serif italic text-brand-bg text-2xl sm:text-4xl leading-snug">
          &quot;Lord, help me to be a shade for those people. Be a good brick to build His kingdom
          among the incarcerated.&quot;
        </p>
        <p className="text-brand-bg/80 mt-6 text-sm uppercase tracking-[0.2em]">— Tumwekwase Felix, Kabale Diocese, Uganda</p>
      </div>
    </section>
  );
}
